import React from 'react';
import classnames from 'classnames';

import { Title } from 'components/Misc/Typography';
import { Button, Datepicker } from 'components/Misc/Form';
import Avatar from 'components/Misc/Avatar';

const className = classnames(
	'py-2 px-3 flex items-center space-x-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Take = ({ take }) => {
	// Get date theme
	// const theme = useMemo(() => {
	// 	const days = Math.abs(DayJs().diff(take.endedAt, 'day'));
	// 	return days >= 7 ? 'danger' : 'warning';
	// }, [take.eventAt]);

	return (
		<div className={className}>
			<div className="flex-1 flex flex-col space-y-2 overflow-hidden">
				<div className="flex-1 flex space-x-4">
					<Avatar
						alt={take.student.fullName}
						src={take.student.avatar}
						online={take.student.online}
					/>

					<Title
						title={take.student.fullName}
						subtitle={take.exam.title}
						className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
					/>
				</div>

				<Datepicker
					time
					readOnly
					value={take.endedAt}
				/>

				{/* <Pill
					theme={theme}
					name={DayJs().to(take.endedAt)}
				/> */}
			</div>

			<Button
				small
				square
				icon="link"
				to={`/exams/results/review/${take.examId}/${take.id}`}
			/>
		</div>
	);
};

export default Take;